import React from 'react'
import "./users.scss"

export const Users = () => {
  return (
    <div class="mainpage">users</div>
  )
}
